module.exports = __webpack_public_path__ + "img/567-42dfb3.png";